exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".SkeletonExpensePageTabs_tabs-wrapper_PaXM {\n  margin-top: 10px;\n\n  display: -webkit-box;\n\n  display: -webkit-flex;\n\n  display: -ms-flexbox;\n\n  display: flex\n}\n.SkeletonExpensePageTabs_tabs-wrapper_PaXM > div {\n  width: 100%;\n  max-width: 114px;\n  height: 36px;\n  border-radius: 8px\n}\n.SkeletonExpensePageTabs_tabs-wrapper_PaXM > div:not(:last-child) {\n  margin-right: 12px;\n}\n", ""]);

// exports
exports.locals = {
	"tabs-wrapper": "SkeletonExpensePageTabs_tabs-wrapper_PaXM"
};